import { Component, ElementRef, ViewChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';


interface AgGridCollapsibleComponentParams {
  isCollapsed: boolean;
}

@Component({
  selector: 'ama-ng-app-store-cell-collapsible',
  templateUrl: './ag-grid-collapsible.component.html',
  styleUrl: './ag-grid-collapsible.component.scss',
  standalone: true
})
export class AgGridCollapsibleComponent implements ICellRendererAngularComp {
  @ViewChild('content') content?: ElementRef;
  @ViewChild('container') container?: ElementRef;
  isCollapsed = true;
  value = '';

  agInit(params: ICellRendererParams & AgGridCollapsibleComponentParams): void {
    this.isCollapsed = params.isCollapsed;
    this.value = params.value;
    params.node.addEventListener('expandedChanged', this.toggleCollapsed.bind(this));
  }

  refresh(_: ICellRendererParams): boolean {
    return false;
  }

  toggleCollapsed() {
    if (this.isCollapsed && this.content?.nativeElement?.offsetHeight <= this.container?.nativeElement?.offsetHeight) {
      return;
    }
    this.isCollapsed = !this.isCollapsed;
  }
}
